export enum SemiConfigProductTypes {
  SANGERCRISPR = 'crispr',
  ORF = 'orf',
  PREDESIGNED_SIRNA = 'sirna',
  PREDESIGNED_SHRNA = 'shrna',
  PREDESIGNED_CRISPR_GRNA = 'crisprgrna',
}

export enum ActiveLinkType {
  ProductSearch = 'productSearch',
  ItemSelection = 'itemSelection',
  Specifications = 'specifications',
  ReviewOrder = 'reviewOrder',
}
export enum uploadErrorType {
  INVALID_TEMPLATE = 'InvalidTemplate',
  MAXIMUM_NUMBER_OF_KEYS = 'MaximumNumberOfKeys',
  UNABLE_TO_PROCESS_FILE = 'UnableToProcessFile',
  EMPTY_FILE = 'EmptyFile',
}
